<template>
    <el-dialog :title="title" :visible="showDialog" @close="close" width="35%">
        <div class="row">
            <div class="col-md-12">
                <label>Nombre</label>
                <el-input v-model="form.name"></el-input>
            </div>

            <div class="col-md-12 mt-3">
                <label>Código</label>
                <el-input v-model="form.code" placeholder="Ejemplo: COCINA, BAR"></el-input>
            </div>

            <div class="col-md-12 mt-3">
                <el-switch v-model="form.active" active-text="Activo" inactive-text="Inactivo"></el-switch>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">Cancelar</el-button>
            <el-button type="primary" @click="submit">Guardar</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['showDialog', 'record'],
    data() {
        return {
            resource: 'restaurant/v2/production-areas',
            form: {},
        }
    },
    computed: {
        title() {
            return this.form.id ? 'Editar área' : 'Nueva área'
        },
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.initForm()
            }
        },
    },
    methods: {
        initForm() {
            this.form = this.record
                ? Object.assign({}, this.record)
                : { id: null, name: null, code: null, active: true }
        },
        close() {
            this.$emit('update:showDialog', false)
        },
        submit() {
            this.$http.post(`/${this.resource}`, this.form).then(response => {
                this.$message.success(response.data.message)
                this.$emit('saved')
                this.close()
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/production_areas/form.vue